/** 基本機能 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';

/** マテリアルデザイン */
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTableModule} from '@angular/material/table';
import {MatSortModule} from '@angular/material/sort';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTabsModule} from '@angular/material/tabs';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {PopoverAlertComponent} from './Common/Popover/Alert/PopoverAlertComponent';
import {ViewSpinnerComponent} from './ViewSpinnerComponent';
import {MatInputModule} from '@angular/material/input';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatDividerModule} from '@angular/material/divider';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatRadioModule} from '@angular/material/radio';

/** 共通View */
import {LineButtonComponent} from './Common/Button/Line/LineButtonComponent';
import {
	ForgetPasswordPopupComponent
} from './Login/EmailPasswordLogin/ForgetPasswordPopup/ForgetPasswordPopupComponent';
import {
	SuccessSendForgetPasswordPopupComponent
} from './Common/SuccessSendForgetPasswordPopup/SuccessSendForgetPasswordPopupComponent';

/** ライブラリ */
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {PopoverConfirmComponent} from './Common/Popover/Confirm/PopoverConfirmComponent';


const MAT_MODULE = [
	MatTabsModule,
	MatTableModule,
	MatSortModule,
	MatPaginatorModule,
	MatFormFieldModule,
	MatInputModule,
	MatSelectModule,
	MatCheckboxModule,
	MatDialogModule,
	MatExpansionModule,
	MatProgressSpinnerModule,
	MatCardModule,
	MatToolbarModule,
	MatButtonModule,
	MatIconModule,
	DragDropModule,
	MatButtonToggleModule,
	MatSidenavModule,
	MatDividerModule,
	MatListModule,
	MatMenuModule,
	MatRadioModule
];



// 共有されるモジュール類はここに設定する
@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		PdfViewerModule,
		MAT_MODULE,
	],
	declarations: [
		PopoverAlertComponent,
		PopoverConfirmComponent,
		ViewSpinnerComponent,
		LineButtonComponent,
		ForgetPasswordPopupComponent,
		SuccessSendForgetPasswordPopupComponent,
	],
	exports: [
		CommonModule,
		FormsModule,
		IonicModule,
		PdfViewerModule,
		PopoverAlertComponent,
		PopoverConfirmComponent,
		ViewSpinnerComponent,
		LineButtonComponent,
		ForgetPasswordPopupComponent,
		SuccessSendForgetPasswordPopupComponent,
		MAT_MODULE,
	],
	entryComponents: [
		PopoverAlertComponent,
		PopoverConfirmComponent,
		ViewSpinnerComponent,
		LineButtonComponent,
		ForgetPasswordPopupComponent,
		SuccessSendForgetPasswordPopupComponent,
	]
})
export class SharedModule { }
